exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".programme-grid{display:grid;grid-template-columns:112px auto;grid-column-gap:24px}.programme-info-grid{display:grid;grid-template-columns:auto min-content;grid-column-gap:24px}.programme-desc{color:var(--black-light-5)}.programme-img{width:112px;height:112px}", ""]);

// exports
